export default __webpack_public_path__ + "static/media/checker2.5d1395a5.jpg";